import { t } from 'i18next'
import type { z } from 'zod'

type TImobiliariaCorretor = { idExterno: string }

type TConfig<T> = {
  getImobiliariaCorretor: (item: T) => TImobiliariaCorretor
  criarPath?: (index: number) => PropertyKey[]
}

const criarPathPadrao = (index: number): PropertyKey[] => [index, 'imobiliariaCorretor']

export const validarImobiliariasCorretoresDuplicados = <T>(
  participacoes: T[],
  ctx: z.RefinementCtx,
  { getImobiliariaCorretor, criarPath = criarPathPadrao }: TConfig<T>,
) => {
  if (!participacoes.length) return

  const contagemPorIdExterno = new Map<string, number>()
  participacoes.forEach((item) => {
    const { idExterno } = getImobiliariaCorretor(item)
    contagemPorIdExterno.set(idExterno, (contagemPorIdExterno.get(idExterno) ?? 0) + 1)
  })

  participacoes.forEach((item, index) => {
    const imobiliariaCorretor = getImobiliariaCorretor(item)
    if ((contagemPorIdExterno.get(imobiliariaCorretor.idExterno) ?? 0) < 2) return

    ctx.addIssue({
      code: 'custom',
      message: t('proposta:detalhes_proposta.imobiliaria.errors.form.duplicado'),
      path: criarPath(index),
      input: imobiliariaCorretor,
    })
  })
}
